var React = require('react');

function CarouselCircleNext (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-1, .cls-2 {\n                fill: none;\n                stroke: #231f20;\n                stroke-miterlimit: 8;\n            }\n            \n            .cls-1 {\n                stroke-linecap: square;\n            }\n            \n            .cls-2 {\n                stroke-linecap: round;\n            }\n        ")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M25.44,40.87l12-12-12-12","key":0}),React.createElement("circle",{"className":"cls-2","cx":"28.87","cy":"28.87","r":"28.37","key":1})]))]);
}

CarouselCircleNext.defaultProps = {"viewBox":"0 0 57.74 57.74"};

module.exports = CarouselCircleNext;

CarouselCircleNext.default = CarouselCircleNext;
